module.exports = {
  name: 'restaurant-list',
  listClass: 'room-list-wrapper',
  defaultLimit: 4,
  itemIndexes: 'code',
}
